































































































































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import cloneDeep from 'lodash/cloneDeep'
import listMixin from '@/mixins/list'
import configurationApi from '@/api/configuration'
import { passwordReg } from '@/utils/regExp'

@Component({
	name: 'Configuration',
	components: {
		PageLayout,
	},
})
export default class Configuration extends Mixins(listMixin) {
	private passwordReg: any = passwordReg
	private editingKey: number = -1
	private cachedData: any = []
	private configureData: any = []
	private columns: any = [
		{
			title: '序号',
			dataIndex: 'key',
			scopedSlots: { customRender: 'key' },
		},
		{
			title: '配置名称',
			dataIndex: 'name',
		},
		{
			title: '生效数据',
			dataIndex: 'effectData',
			scopedSlots: { customRender: 'effectData' },
		},
		{
			title: '操作',
			key: 'operation',
			scopedSlots: { customRender: 'operation' },
		},
	]

	private save(record: any) {
		if (record && record.regExp) {
			const reg = new RegExp(record.regExp)
			if (!reg.test(record.effectData)) {
				this.$message.error(`${record.title}生效数据不合法`)
				return
			}
		}

		// 校验密码
		if (record.dicKey === 'INITPWD') {
			if (!passwordReg.test(record.effectData)) {
				this.$message.error(
					'请设置8-16位长度密码，包含数字、大小写字母及特殊符号中至少三种'
				)
				return
			}
		}

		configurationApi
			.updateConfiguration({ id: record.id, effectData: record.effectData })
			.then((res: any) => {
				this.editingKey = -1
				this.getDataCached()
			})
	}

	private cancel() {
		this.configureData = cloneDeep(this.cachedData)
		this.editingKey = -1
	}

	private edit(record: any) {
		if (record.dicKey === 'HOLIDAY') {
			this.$router.push('/Settings/Holiday')
		} else if (record.dicKey === 'SETTLEMENT') {
			this.$router.push('/Settings/Settlement')
		} else {
			this.editingKey = record.key
		}
	}

	private updateData(value: string, key: string | number, col: string) {
		const newData = [...this.configureData]
		let temp = newData.find(item => item.key === key)
		if (temp) {
			temp[col] = value
			this.configureData = newData
		}
	}

	private handleChange(value: string, key: string | number, col: string) {
		this.updateData(value, key, col)
	}

	private handleBlur(value: string = '', key: string | number, col: string) {
		this.updateData(value.trim(), key, col)
	}

	public getList() {
		return configurationApi
			.getConfigurationList(this.getSearchValues())
			.then((res: any) => {
				const data = (res.data && res.data.retList) || []
				this.configureData = data.map((item: any, index: number) => {
					return Object.assign({}, item, { key: index + 1 })
				})
				this.total = res.data && res.data.count
				this.getDataCached()
			})
	}

	private getDataCached() {
		this.cachedData = cloneDeep(this.configureData)
	}

	public activated() {
		this.getList()
	}
}
